import $ from 'jquery';
import _ from 'underscore';
import { showPopup } from '@bingads-webui/automatic-positioning-popover';
import { DeterministicViewForBackBoneView } from '@bingads-webui/deterministic-wrapper-view';
import { PopupContentView } from './view';

let contentView;
let timeoutForBudgetLandscapePopover;

export function dismissHelpInfo() {
  if (contentView) {
    contentView.trigger('remove');
  }
  contentView = null;
}

export function getTemplate({
  targetEntity,
  i18n,
  eventName,
  isForecasting,
}) {
  const view = new PopupContentView({
    i18n,
    targetEntity,
    eventName,
    isForecasting,
  });

  return view.template();
}

export function showHelpInfo({
  event,
  targetEntity,
  i18n,
  showSuggestionClickedCallback,
  eventName,
  isForecasting,
}) {
  const container = $('.budget-lanscape-popover-container');

  dismissHelpInfo();
  clearTimeout(timeoutForBudgetLandscapePopover);

  timeoutForBudgetLandscapePopover = setTimeout(() => {
    const view = new PopupContentView({
      i18n,
      targetEntity,
      eventName,
      isForecasting,
    });

    if (_.isFunction(showSuggestionClickedCallback)) {
      view.on('budget-landscape-action-link:clicked', () => {
        dismissHelpInfo();
        showSuggestionClickedCallback();
      });
    }

    contentView = new DeterministicViewForBackBoneView({ view: view.render() });

    return showPopup({
      contentView,
      i18n,
      container,
      classes: ['budget-landscape-help-info-container'],
      anchor: $(event.target),
    });
  }, 200);
}
